<fieldset>
    <legend>Business Address</legend>

    <AddressGroup id="business-address"
                  [address]="businessAddress"
                  (onValueChange)="updateBusinessAddress($event)">
    </AddressGroup>

    <div class="row">
        <div class="col-8">
            <div class="input-wrapper">
                <MaskedValidatedTextField class=""
                                          [label]="'Phone Number'"
                                          id="phonenum"
                                          [text]="businessPhone.Phone"
                                          (onValueChange)="businessPhone.Phone=$event"
                                          [maxlength]="10"
                                          [inputMask]="phoneNumberInputMask"
                                          [validators]="[notBlankValidator, lengthValidator,numericValidator]">
                </MaskedValidatedTextField>
            </div>
        </div>
        <div class="col-8">
            <div class="input-wrapper">
                <MaskedValidatedTextField class=""
                                          [label]="'Cell Number (optional)'"
                                          id="cellnum"
                                          [text]="cellPhone.Phone"
                                          (onValueChange)="cellPhone.Phone=$event"
                                          [maxlength]="10"
                                          [inputMask]="phoneNumberInputMask">
                </MaskedValidatedTextField>
            </div>
        </div>
    </div>
</fieldset>



<fieldset>
    <legend>Residential Address</legend>
    <div class="row">
        <div class="col-16">
            <div class="detail-info">
                <input type="checkbox"
                       class="option__input"
                       id="same-as-business-address"
                       [checked]="sameAsBusinessAddress"
                       (click)="clickOnSameAsBusinessAddress()" />
                <label for="same-as-business-address"> Same as business address </label>
            </div>
        </div>
    </div>
    <AddressGroup id="residential-address"
                  [address]="residentialAddress"
                  [disabled]="sameAsBusinessAddress"
                  (onValueChange)="onResidentialAddressChange.emit($event)">
    </AddressGroup>
</fieldset>

<!--<div class="row"  *ngIf="isAdminUpdate"> 
    <div class="col-24">
        <div class="bottom-10">
            <ValidatedCheckbox [id]="'Opt-in-to-Silver-Mail-notifications'"
                               [label]="'Opt-in to Silver Mail Notifications'"
                               [checked]="silverMailOptIn"
                               (onValueChange)="onsilverMailOptInChange.emit($event)">
                
            </ValidatedCheckbox>
        </div>
    </div>
</div>-->


